// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eye-opacity {
    opacity: 50%;
}`, "",{"version":3,"sources":["webpack://./src/views/Login/styles/loginStyles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB","sourcesContent":[".eye-opacity {\r\n    opacity: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
